import { DataEntryVehicleStepSectionProps, typedMemo } from "src/types";
import { FormRow, InputDate, InputGroup, InputText } from "src/ui/widgets";
import { useDataEntryVehicleStepInsuranceCompany } from "./vehicle-step-insurance-company.hook";

export const DataEntryVehicleStepInsuranceCompany = typedMemo(
  ({
    formikFieldBaseName,
    formikVehicleValues,
    formikVehicleErrors,
    formikVehicleTouched,
    formik,
    validationSchema,
  }: DataEntryVehicleStepSectionProps) => {
    const { yesNoOptions, t } = useDataEntryVehicleStepInsuranceCompany();

    const { handleChange, handleBlur, setFieldTouched, setFieldValue } = formik;

    return (
      <>
        <FormRow
          firstField={
            <InputText
              name={`${formikFieldBaseName}.company.policyNumber`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.company?.policyNumber}
              value={formikVehicleValues.company.policyNumber}
              error={formikVehicleErrors?.company?.policyNumber}
              label={`${t("commons.policy_number")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputText
              name={`${formikFieldBaseName}.company.greenCard.number`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.company?.greenCard?.number}
              value={formikVehicleValues.company.greenCard?.number}
              error={formikVehicleErrors?.company?.greenCard?.number}
              label={`${t("commons.green_card_number")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputDate
              name={`${formikFieldBaseName}.company.greenCard.startDate`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.company?.greenCard?.startDate}
              value={formikVehicleValues.company.greenCard?.startDate}
              error={formikVehicleErrors?.company?.greenCard?.startDate}
              label={`${t("commons.valid")} ${t("commons.from")}`}
              placeholder={t("commons.insert")}
              disabledTo={undefined}
              classes="m-0 p-0"
            />
          }
          secondField={
            <InputDate
              name={`${formikFieldBaseName}.company.greenCard.endDate`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.company?.greenCard?.endDate}
              value={formikVehicleValues.company.greenCard?.endDate}
              error={formikVehicleErrors?.company?.greenCard?.endDate}
              label={`${t("commons.to")}`}
              placeholder={t("commons.insert")}
              disabledTo={undefined}
              classes="m-0 p-0"
            />
          }
        />
        <FormRow
          firstField={
            <InputText
              name={`${formikFieldBaseName}.company.companyName`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.company?.companyName}
              value={formikVehicleValues.company?.companyName}
              error={formikVehicleErrors?.company?.companyName}
              label={`${t("commons.company_name")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputText
              name={`${formikFieldBaseName}.company.agencyName`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.company?.agencyName}
              value={formikVehicleValues.company?.agencyName}
              error={formikVehicleErrors?.company?.agencyName}
              label={`${t("commons.agency_name")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputGroup
              style="radio"
              name={`${formikFieldBaseName}.company.materialDamageCoverage`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              options={yesNoOptions}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.company?.materialDamageCoverage}
              value={formikVehicleValues.company.materialDamageCoverage}
              error={formikVehicleErrors?.company?.materialDamageCoverage}
              label={t(
                "data_entry.vehicle_step.section_insurance_question_material_damages"
              )}
              classes="m-0 ps-0"
              classesLabel="m-0 p-0 d-flex align-items-center mb-3"
            />
          }
        />
      </>
    );
  }
);
